import { Link } from 'react-router-dom';
import { MaterialIcon } from '@/components/common/MaterialIcon';
import { Container } from '@/components/common/Container';
import { Button } from '@/components/ui/button';

interface PlaceholderPageProps {
  title: string;
  description: string;
  phase: string;
}

/**
 * Generic "coming in Phase N" page used as a route target until the matching
 * feature ships. Keeps the user inside the brand experience instead of 404.
 */
export function PlaceholderPage({ title, description, phase }: PlaceholderPageProps) {
  return (
    <Container className="py-24 text-center">
      <span className="mb-4 inline-block rounded-full bg-secondary-container px-4 py-1 font-label-caps text-label-caps text-on-secondary-container">
        {phase}
      </span>
      <h1 className="mb-6 font-headline-md text-headline-md text-primary">{title}</h1>
      <p className="mx-auto mb-10 max-w-xl font-body-lg text-body-lg text-on-surface-variant">
        {description}
      </p>
      <Button asChild>
        <Link to="/">
          <MaterialIcon name="arrow_back" />
          Back to home
        </Link>
      </Button>
    </Container>
  );
}
